var render = function render(){var _vm=this,_c=_vm._self._c;return _c('merge-checks-message',{attrs:{"check":_vm.check},scopedSlots:_vm._u([{key:"failed",fn:function(){return [_c('action-buttons',{attrs:{"tertiary-buttons":_vm.tertiaryActionsButtons}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }